import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
  isSideBarOpen: boolean;
  isSideBarCollapse: boolean;
  isFullscreenMode: boolean;
}

interface SidebarActions {
  toggleSideBar: () => void;
  closeSideBar: () => void;
  collapseSideBarOn: () => void;
  collapseSideBarOff: () => void;
  setSideBarOpen: (isOpen: boolean) => void;
  setSideBarCollapse: (isCollapse: boolean) => void;
  setFullscreenMode: (isFullscreen: boolean) => void;
}

export type SidebarStore = SidebarState & SidebarActions;

export const useSidebarStore = create<SidebarStore>()(
  persist(
    (set) => ({
      // State
      isSideBarOpen: false,
      isSideBarCollapse: true,
      isFullscreenMode: false,

      // Actions
      toggleSideBar: () =>
        set((state) => ({
          isSideBarOpen: !state.isSideBarOpen,
        })),

      closeSideBar: () =>
        set({
          isSideBarOpen: false,
        }),

      collapseSideBarOn: () => {
        set({ isSideBarCollapse: true });
      },

      collapseSideBarOff: () => {
        set({ isSideBarCollapse: false });
      },

      setSideBarOpen: (isOpen: boolean) =>
        set({
          isSideBarOpen: isOpen,
        }),

      setSideBarCollapse: (isCollapse: boolean) =>
        set({
          isSideBarCollapse: isCollapse,
        }),

      setFullscreenMode: (isFullscreen: boolean) =>
        set({
          isFullscreenMode: isFullscreen,
        }),
    }),
    {
      name: 'sidebar-store',
      partialize: (state) => ({
        isSideBarCollapse: state.isSideBarCollapse,
        // Don't persist isSideBarOpen as it should reset on page reload
      }),
    },
  ),
);
